<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <form @submit.prevent="handleSubmit(submitAction)" class="grid gap-4">
      <ValidationProvider rules="required" name="url" tag="div" vid="url">
        <template #default="{ errors, failed }">
          <BaseFormGroup>
            <BaseFormLabel>Url</BaseFormLabel>
            <BaseFormInput v-model="data.url" type="url" :disabled="active" :invalid="failed" />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider name="title" tag="div" vid="title">
        <template #default="{ errors, failed }">
          <BaseFormGroup>
            <BaseFormLabel>Title</BaseFormLabel>
            <BaseFormInput v-model="data.title" :disabled="active" :invalid="failed" />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider name="description" tag="div" vid="description">
        <template #default="{ errors, failed }">
          <BaseFormGroup>
            <BaseFormLabel>Description</BaseFormLabel>
            <BaseFormTextarea v-model="data.description" :disabled="active" :invalid="failed" />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <div class="grid grid-flow-col gap-2 justify-start">
        <BaseButton primary :disabled="active || invalid">
          <Loader v-if="active" small inverse />
          <template v-else> Create </template>
        </BaseButton>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  props: {
    projectId: {
      type: String,
      required: true,
    },
    onData: {
      type: Function,
      default: (data) => data,
    },
    onLinkAssetCreated: {
      type: Function,
      default: null,
    },
    onActive: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      active: false,
      data: {
        url: null,
        title: null,
        description: null,
      },
    };
  },

  methods: {
    setActive(active) {
      this.active = active;
      if (typeof this.onActive === 'function') {
        this.onActive(active);
      }
    },
    resetForm() {
      this.data.url = null;
      this.data.title = null;
      this.data.description = null;
    },
    async submitAction() {
      try {
        this.setActive(true);

        const { projectAssetId } = await this.$store.dispatch({
          type: 'ui/projectProjectAssets/storeLink',
          projectId: this.projectId,
          formData: this.onData(this.data),
        });

        if (typeof this.onLinkAssetCreated === 'function') {
          this.onLinkAssetCreated(projectAssetId);
        }

        this.$emit('link-created');

        this.resetForm();
      } catch (error) {
        // handle error
      } finally {
        this.setActive(false);
      }
    },
  },
};
</script>
